import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-modules',
  templateUrl: './table-modules.component.html',
  styleUrls: ['./table-modules.component.scss'],
})
export class TableModulesComponent implements OnInit {
  @Input() scroll: any = { x: '1100px', y: '100%' };

  constructor() {}

  ngOnInit(): void {}
}
